module.exports = __webpack_public_path__ + "images/sam/menuitem_submenuindicator_disabled.png";